import $ from 'jquery';

const TFL_PARAM_START = 'tfl=';
const QUESTION_MARK = '?';
const AMPERSAND = '&';

// Will end up calling a delegator for both the scores and the schedule pages
const addTicketLinkDelegators = (makeTFL) => {
    // Handles ticket links added to bdata-react-scores-game in SnS app
    addTicketLinkDelegator(makeTFL, 'scoreboard', '.bdata-react-scores-tickets-link', 'Schedule', 'Scoreboard');
    addTicketLinkDelegator(makeTFL, 'schedule', '.bdata-react-schedule-tickets-link', 'Scoreboard', 'Schedule');
};

// Sets up a jquery delegator to listen for clicking on a ticket class name
const addTicketLinkDelegator = (makeTFL, component, ticketClassName, replaceFrom, replaceTo) => {
    $('#scores-schedule-root').on('click', ticketClassName, (event) => {
        // Retrieve the intercepted url from the event

        const interceptedUrl = event && event.currentTarget && event.currentTarget.href;

        // If we have the url and the makeTFL library, generate a new link with tracking info
        if (interceptedUrl && makeTFL) {
            // Prevent the browser from following the ticket link clicked
            event.preventDefault();

            // generate the tfl param using the library attached to window
            const generatedTFLBase = makeTFL({
                url: interceptedUrl,
                component
            });

            const reg = new RegExp(replaceFrom, 'g');

            // this is a heck. this needs to be done because makeTFL get section name from pageMeta.
            const generatedTFL = generatedTFLBase.replace(reg, replaceTo);

            // Found cases with and without 'tfl=' so let's make one if one isn't found
            const tflStart = `${generatedTFL.indexOf(TFL_PARAM_START) === -1 ? TFL_PARAM_START : ''}`;

            // Create either ? or & based on existence of params in initial url
            const paramAddition = `${interceptedUrl.indexOf(QUESTION_MARK) === -1 ? QUESTION_MARK : AMPERSAND}`;

            // Combine all segments
            const newHref = `${interceptedUrl}${paramAddition}${tflStart}${generatedTFL}`;

            // Better safe than sorry
            if (window) {
                window.open(newHref, '_blank');
            }
        }
    });
};

export default addTicketLinkDelegators;
